<template>
  <v-container fluid class="pa-0">
    <WidgetDashboard v-if="isDashboardEnabled" />
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'


  import WidgetDashboard from '@/components/Dashboard/WidgetDashboard'


  const dashboard = createNamespacedHelpers('dashboard')
  export default {
    components: {
      WidgetDashboard,
    },
    computed: {
      ...dashboard.mapGetters(['isDashboardEnabled']),
    },
    methods: {
      ...dashboard.mapActions(['fetchDashboardConfig']),
    },
    created() {
      this.fetchDashboardConfig()
    },
  }
</script>
